import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Router } from '@angular/router';
import { ClientBusinessDetail } from 'src/app/Models/Response';
import { AppComponent } from 'src/app/app.component'; 
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.css']
})
export class ClientListComponent implements OnInit {
  isPopupVisible: boolean = false;

  onButtonClick(businessid:string,clientid:string,getclientname:string,getbusinessname:string): void {
    this.isPopupVisible = true;  // Show the popup
    this.BusinessInfoId=businessid;
    this.ClientUserId=clientid;
    this.clientname=getclientname;
    this.businessname=getbusinessname;
  }

  closePopup(): void {
    this.isPopupVisible = false;  // Hide the popup
  }

  displayedColumns: string[] = ['ClientName','ClientBusinessName','ClientEmail','ClientNumber', 'actions'];
  dataSource : any;
  UserId: string = "";
  FirstName: string = "";
  UserNameAsPhoto: string = "";
  ManagerUserId: string = "";
  ClientUserId: string = "";
  BusinessInfoId: string = "";
  clientname: string = "";
  businessname: string = "";
  ManagerClientData : ClientBusinessDetail[] = [];

  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  constructor(public service: SharkifyAiSerivceService, public router : Router, public app: AppComponent,private toastr: ToastrService) {}
  ngOnInit(): void {

    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.ManagerUserId= this.UserId ;
    localStorage.setItem("ManagerUserId", "" + this.ManagerUserId);
    this.getData();
   
    // const businesses: Client[] = [
    //   {
    //     ClientName : 'sravan',
    //     Created_On: new Date('2024-10-03')
    //   },
    //   {
    //     ClientName : 'Manish',
    //     Created_On: new Date('2024-10-07')
    //   }
    // ];

    // this.dataSource.data = businesses;
  }
  getData(){
    this.app.displayLoader(true);
    this.service.NewClientsWithBusinessDetails(this.UserId).subscribe(data => {
      this.app.displayLoader(false);
      if (data.Code == 200) {
        this.ManagerClientData=data.ClientBusinessDetails;
        // this.ManagerClientData.forEach((element,i) => {
        //   element.UserImageText = Array.from(element.ClientFirstName)[0] + "" + Array.from(element.ClientLastName)[0];
        // })

        this.ManagerClientData.forEach(element => {
          element.ClientFullName = element.ClientFirstName + ' ' + element.ClientLastName;
          element.ManagerImageText= `${Array.from(element.ClientFullName)[0]}`;
          element.isImageAvailable = element.ClientPhoto == null || element.ClientPhoto == "" || element.ClientPhoto == "null" ? false : true;
        });
        
        // this.UserNameAsPhoto = `${Array.from(this.FirstName)[0]}`;
        this.dataSource = new MatTableDataSource(this.ManagerClientData);
      } else {
      }
    });
  }
  sendRequest(){
    this.app.displayLoader(true);
    this.service.SendBusinessAccountAccessRequest(this.ManagerUserId,this.ClientUserId,this.BusinessInfoId).subscribe(data => {
      this.app.displayLoader(false);
      if (data.Code == 200) {
        // this.getData();
        // this.ClientBusinessData=data.UserDetails;
        // this.ClientBusinessData.forEach((element: any, i: any) => {
        //   element.ClientFullName = element.ClientFirstName + ' ' + element.ClientLastName;
        //   element.CreatedOn_text = element.CreatedOn == null || element.CreatedOn == undefined ? "" : this.datepipe.transform(element.CreatedOn,"yyyy-MMM-dd")+ "";
        // });
        
        // this.dataSource = new MatTableDataSource(this.ClientBusinessData);
        this.toastr.success('Request Sent successfully!','Success');
      } else {
        this.toastr.error('Request Already Sent!','Error');
      }
    });

  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
